import React, { useEffect } from "react";
import EmailIcon from "../../assets/icons/alert-management-icons/email-icon";
import SmsIcon from "../../assets/icons/alert-management-icons/sms-icon";
import WhatsappIcon from "../../assets/icons/alert-management-icons/whatsapp-icon";
import PushNotificationIcon from "../../assets/icons/alert-management-icons/push-notification-icon";

import { useFormikContext } from "formik";

function Preview({ setShowPreview, showPreview, activeTab, activeTabData }) {
  let icon 
  if (activeTab === "Email") {
    icon =<EmailIcon/>
    // textAreaPlaceholder = "Enter description";
    // textAreaLabel = "Email Content";
    // subjectLable = "Email Subject";
  } else if (activeTab === "SMS") {
    icon = <SmsIcon/>
    // textAreaPlaceholder = "Message here";
    // textAreaLabel = "Message Content";
  } else if (activeTab === "WhatsApp") {
    icon = <WhatsappIcon/>
    // textAreaPlaceholder = "Message here";
    // textAreaLabel = "Message Content";
  } else if (activeTab === "Push Notification") {
    icon = <PushNotificationIcon/>
    // textAreaPlaceholder = "Enter description";
    // textAreaLabel = "Message Content";
    // subjectLable = "Push Title ";
  }
  const openModal = () => {
    setShowPreview(true);
  };

  const closeModal = () => {
    setShowPreview(false);
  };

  // Handle ESC key press
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape" && showPreview) {
        closeModal();
      }
    };

    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [showPreview]);

  // Prevent body scroll when modal is open
  useEffect(() => {
    if (showPreview) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showPreview]);

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      closeModal();
    }
  };
  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-[rgba(0,0,0,0.7)]
 backdrop-blur-sm z-50"
      onClick={handleOverlayClick}
    >
      <div className="flex flex-col gap-4 bg-white p-6 rounded-xl max-w-[362px] min-w-[362px]">
        <label
          className={
            "text-[length:var(--alert-management-title-fs)] font-[var(--alert-management-title-fw)] text-[var(--alert-management-preview-title-text-color)]"
          }
        >
          Preview
        </label>
        <div className="flex flex-col gap-2 p-3 rounded-lg bg-[var(--alert-management-variable-bg)]">
          <div className="flex flex-row items-center gap-2">
            {icon}

            <label
              className={
                "text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-variable-fw)] text-[var(--alert-management-label-color)]"
              }
            >
              {activeTab} Preview
            </label>
          </div>

          <p className="text-[length:var(--alert-management-variable-fs)] font-[var(--alert-management-sub-title-fw)] text-[var(--alert-management-preview-text-color)]">
            Subject: {activeTabData.subject}
          </p>
          <p className="  text-[length:var(--alert-management-variable-fs)] font-[var(--alert-management-variable-fw)] text-[var(--alert-management-preview-text-color)]">
            {activeTabData.body}
          </p>
        </div>
      </div>
    </div>
  );
}

export default Preview;
